import Aos from "aos";

try {
    Aos.init();
} catch (error) {
    console.error(error);
}